import styled from 'styled-components'

export const SelectPeopleWrapper = styled.div`
    width: 50%;
`

